import React, { Component } from 'react';

class Modal_Number extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImageIndex: 0,
      direction: null,
      transitioning: false
    };
  }

  getImages = () => {
    const { number } = this.props;
    return [
      number.img,
      `${number.img.split('.')[0]}_2.jpg`,
      `${number.img.split('.')[0]}_3.jpg`,
    ];
  };


  nextImage = () => {
    if (this.state.transitioning) return;
    const { number } = this.props;
    const images = this.getImages();

    this.setState({ 
      transitioning: true,
      direction: 'next' 
    });
    
    setTimeout(() => {
      this.setState(prevState => ({
        currentImageIndex: prevState.currentImageIndex === images.length - 1 
          ? 0 
          : prevState.currentImageIndex + 1,
        transitioning: false,
        direction: null
      }));
    }, 800); 
  };

  prevImage = () => {if (
    this.state.transitioning) return;

    const images = this.getImages();

    this.setState({ 
      transitioning: true,
      direction: 'prev' 
    });
    
    setTimeout(() => {
      this.setState(prevState => ({
        currentImageIndex: prevState.currentImageIndex === 0 
          ? images.length - 1 
          : prevState.currentImageIndex - 1,
        transitioning: false,
        direction: null
      }));
    }, 800);
  };

  closeModal = () => {
    this.setState({
        currentImageIndex: 0, // Сбрасываем индекс на первое фото
        direction: null,
        transitioning: false
    }, () => {
        this.props.onClose(); // Вызываем родительский метод закрытия
    });
};

  render() {
    const { isOpen,  number } = this.props;
    const { currentImageIndex, direction } = this.state;
    const images = this.getImages();

    if (!isOpen) return null;

    const nextIndex = currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1;
    const prevIndex = currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1;

    return (
      <div className="modal-overlay_number">
        <div className="number-modal-content-number">
          <button className="close-button" onClick={this.closeModal}>×</button>
          
          <div className="number-modal-gallery">
            <button className="gallery-nav prev" onClick={this.prevImage}>❮</button>


            <div className={`image-container ${
        direction === 'next' ? 'slide-left' : 
        direction === 'prev' ? 'slide-right' : ''
    }`}>
            <img 
              src={`./img/${images[currentImageIndex]}`} 
              alt={number.title} 
              className='photo_modal_height'
            />
            </div>

            {/* Следующее/предыдущее изображение */}
    {direction && (
        <div className={`image-container ${
            direction === 'next' ? 'from-right' : 'from-left'
        }`}>
            <img 
                src={`./img/${direction === 'next' ? images[nextIndex] : images[prevIndex]}`} 
                alt={number.title} 
            />
        </div>
    )}
            
            <button className="gallery-nav next" onClick={this.nextImage}>❯</button>
          </div>

          <div className="number-modal-info">
            <h2>{number.title}</h2>
            <p className="price">{number.price}</p>
            <p className="square">Площадь: {number.square} м²</p>
            <p className="description">{number.desc}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal_Number;